var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 21C1 9.95431 9.95431 1 21 1C32.0457 1 41 9.95431 41 21C41 32.0457 32.0457 41 21 41C9.95431 41 1 32.0457 1 21Z",
    stroke: "#0C0900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6654 16.8668C27.1643 17.0842 26.6343 17.2279 26.092 17.2935C26.6641 16.9517 27.0929 16.414 27.2987 15.7801C26.7611 16.1002 26.1725 16.3257 25.5587 16.4468C25.1484 16.0019 24.602 15.7057 24.0052 15.6047C23.4085 15.5037 22.7951 15.6037 22.2612 15.8889C21.7274 16.1742 21.3033 16.6285 21.0555 17.1807C20.8077 17.7329 20.7502 18.3517 20.892 18.9401C19.805 18.8852 18.7417 18.6021 17.7711 18.1094C16.8006 17.6167 15.9446 16.9253 15.2587 16.0801C15.0181 16.5003 14.8917 16.976 14.892 17.4601C14.8912 17.9097 15.0015 18.3526 15.2132 18.7492C15.4249 19.1458 15.7314 19.4839 16.1054 19.7335C15.6707 19.7216 15.2453 19.605 14.8654 19.3935V19.4268C14.8686 20.0567 15.0894 20.6662 15.4902 21.1521C15.8911 21.638 16.4475 21.9706 17.0654 22.0935C16.8275 22.1659 16.5806 22.204 16.332 22.2068C16.16 22.2048 15.9883 22.1892 15.8187 22.1601C15.9946 22.702 16.3351 23.1756 16.7927 23.5149C17.2504 23.8543 17.8024 24.0425 18.372 24.0535C17.4102 24.8103 16.2226 25.2234 14.9987 25.2268C14.7759 25.2275 14.5532 25.2142 14.332 25.1868C15.5817 25.9936 17.0379 26.422 18.5254 26.4201C19.5518 26.4308 20.5701 26.2368 21.5208 25.8495C22.4714 25.4622 23.3354 24.8894 24.0622 24.1645C24.789 23.4395 25.364 22.5771 25.7537 21.6274C26.1435 20.6778 26.3401 19.66 26.332 18.6335V18.2801C26.8552 17.89 27.3063 17.4118 27.6654 16.8668Z",
    fill: "#0C0900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2a0159fab32119a3a58135ce166bee23.svg";
export { ForwardRef as ReactComponent };